import React from 'react'

const Inicio = ({auth}) => {
  return (
    <div className='logo-principal'>
  
    </div>
  )
}

export default Inicio